<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { get } from 'lodash';
import { Gigya } from 'src/modules/gigya_module';

export default {
  mixins: [fandomBasicMixin],
  data: function() {
    return {
      activeItem: null,
    };
  },
  mounted() {
    Vue.nextTick(() => {
      disableBodyScroll(this.$el);
    });
  },
  beforeDestroy() {
    clearAllBodyScrollLocks();
  },
  methods: {
    isUserRegistered: Fandom.isUserRegistered,
    getTarget: Fandom.getTarget,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    logout() {
      const _gigya = new Gigya("IT");
      _gigya.logout();
    },
    getItemUrl(item) {
      return item.url.url == "#" ? "javascript:void(0)" : item.url.url;
    },
    itemClick(item) {
      if (item.menu) {
        this.activeItem = item;
      }
    }
  },
  computed: {
    user() {
      return get(this.globalState.pageModel, ["user"], false);
    },
  },
};
</script>

<template>
  <div class="position-fixed mh-100vh" sidebar-component>
    <div class="position-absolute w-100 bg-white d-flex flex-column">
      <div class="px-3 py-2 border-bottom w-100 position-relative">
        <div class="mx-3 my-1">
          {{ ft("globals.menu") }}
        </div>
        <div class="close-icon position-absolute" @click="$emit('sidebarClose', true)">
          <i class="fal fa-times"></i>
        </div>
      </div>
      <div v-for="(item, index) in content.menu" class="px-3 py-2 border-bottom w-100" :key="`menu-item-${index}`">
        <div class="mx-3 my-1 d-flex justify-content-between align-items-center">
          <a class="link-black w-100 text-uppercase" :href="getItemUrl(item)" :target="getTarget(item.url)">
            {{ item.url.title }}
          </a>
          <i v-if="item.menu" @click="itemClick(item)" class="far fa-chevron-right"></i>
        </div>
      </div>
      <template v-if="!user || user.anonymous">
          <div class="px-3 py-2 border-top w-100">
            <div class="mx-3 my-1">
              <a class="link-black" href="/users/sign_in">
                {{ ft("globals.login.login") }}
              </a>
            </div>
          </div>
          <div class="px-3 py-2 w-100 bg-red-cabbage">
            <div class="mx-3 my-1">
              <a class="link-white" href="/users/sign_up">
                {{ ft("globals.login.sign_up") }}
              </a>
            </div>
          </div>
      </template>
      <template v-else>
        <div class="px-3 py-2 border-bottom w-100 bg-orange" v-if="content.profile_menu" sidebar-item-component>
          <div class="mx-3 my-1 text-uppercase subitem">
            <a 
              href="#item-profile" 
              data-toggle="collapse"
              class="text-white collapsed d-flex justify-content-between align-items-center"
            >
              {{user.username}}
              <i v-if="content.profile_menu" class="fal fa-chevron-right text-lg ml-3"></i>
            </a>
          </div>
        </div>
        <div id="item-profile" class="collapse">
          <div class="px-3 py-2 border-bottom w-100">
            <div v-for="(link, i) in content.profile_menu" :key="`link-profile-${i}`" class="py-1">
              <a 
                :href="link.url.url" 
                class="link-black text-capitalize ml-3" 
                :target="getTarget(link.url)"
              >
                {{link.url.title}}
              </a>
            </div>
            <div class="py-1">
              <a 
                href="/users/sign_out" 
                @click.prevent="logout()"
                class="link-black text-capitalize ml-3" 
              >
                logout
              </a>
            </div>
          </div>
        </div>
      </template>
      <div v-for="(item, index) in content.top_links" class="px-3 py-2 border-bottom w-100" :key="`top-link-item-${index}`">
        <div class="mx-3 my-1 d-flex justify-content-between align-items-center">
          <a class="link-black w-100" :href="getItemUrl(item)" :target="getTarget(item.url)">
            {{ item.url.title }}
          </a>
        </div>
      </div>
    </div>
    <transition enter-active-class="animated faster slideInLeft" leave-active-class="animated faster slideOutLeft">
      <sidebar-item 
        v-if="!!activeItem" 
        :item="activeItem" 
        v-on:sidebar-item-close="activeItem = null"
      ></sidebar-item>
    </transition>
  </div>
</template>

<style lang="scss">
[sidebar-component] {
  z-index: $zindex-menu-item + 2;
  top: 0;
  width: 70vw;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  & > div:first-child {
    min-height: 100%;
  }

  .close-icon {
    z-index: 3;
    font-size: 1.5rem;
    opacity: .85;
    line-height: .85rem;
    right: 1rem;
    top: .75rem;
  }

  a {
    text-decoration: none !important;
  }

  [sidebar-item-component], & {
    @each $color-name, $color-val in $kenwood-colors {
      .sidebar-link-#{$color-name} {
        transition: all 0.3s;
        color: $black;
        &:hover, &:active, &:focus, &:visited {
          color: $color-val;
        }
        &.collapsed {
          color: $black;
        }
      }
    }

    .subitem {
      & > a:not(.collapsed),
      & > a:not(.collapsed) > i {
        transition: all .25s;
      }

      & > a:not(.collapsed) > i {
        transform: rotate(90deg);
      }
    }

    .url-lg {
      font-family: $bressay-font;
    }
  }

}
</style>
